// constants.js
import config from '../../config';

export const CLIENT_ID = `${config.ebayClientId}`;
export const RuName = `${config.ebayRuName}`;
export const SCOPES = encodeURIComponent(
  'https://api.ebay.com/oauth/api_scope https://api.ebay.com/oauth/api_scope/sell.inventory https://api.ebay.com/oauth/api_scope/sell.reputation.readonly https://api.ebay.com/oauth/api_scope/sell.account.readonly'
);
